export const linear = t => +t;



//////////////////
// WEBPACK FOOTER
// ./~/d3-ease/src/linear.js
// module id = 474
// module chunks = 0